import type { consents as en } from '@/i18n/locales/en/consents';
import type { Translation } from '@/i18n/types';

export const consents: Translation<typeof en> = {
  title: 'Vos consentements',
  empty: 'Aucune demande de consentement ne vous concerne.',
  collectiveNote:
    "Un enregistrement collectif est en vigueur pour le département ; votre réponse personnelle n'a aucun effet tant qu'il reste en vigueur.",
  table: {
    department: 'Département',
    status: 'Statut',
    basis: 'Base en vigueur',
  },
  status: {
    pending: 'En attente de votre réponse',
    granted: 'Accordé',
    denied: 'Refusé',
  },
  basis: {
    personal: 'Personnelle',
    collective: 'Collective',
  },
  actions: {
    grant: 'Accorder',
    deny: 'Refuser',
    withdraw: 'Retirer',
  },
};
